import { render, staticRenderFns } from "./SoloPlanos.vue?vue&type=template&id=7fd2fdcc&scoped=true"
import script from "./SoloPlanos.vue?vue&type=script&lang=js"
export * from "./SoloPlanos.vue?vue&type=script&lang=js"
import style0 from "./SoloPlanos.vue?vue&type=style&index=0&id=7fd2fdcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd2fdcc",
  null
  
)

export default component.exports